/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 10b70efd47036b72e8d1dec5d12405f81f712e3a
 */

/**
 * Publication product type enumeration.
 */
export type ProductKind = typeof ProductKind[keyof typeof ProductKind];


export const ProductKind = {
  ebook: 'ebook',
  audio: 'audio',
} as const;
